import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-h3',
    templateUrl: './h3.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class H3Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
